var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('iframe',{staticClass:"frame-area",attrs:{"name":"Framename","src":'https://portal.games.edc.hostville.link/api/h5p/' + _vm.contentId,"frameborder":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }